import SideMenuOptionsIfo from './SideMenuOptionsIfo';

export default SideMenuOptionsIfo;
